// extracted by mini-css-extract-plugin
export var pagination = "pagination-module--pagination--R6ih8";
export var active = "pagination-module--active--gA2+v";